import React from 'react';
import IconBase from 'react-icon-base';

class OverviewIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <IconBase viewBox="-0.312 0.5 53 53" {...this.props}>
                <path
                    // eslint-disable-next-line
                    d="M25.478,13.811L13.75,24.203v13.607h23.5v-2.193H15.974V25.182l9.504-8.424l9.505,8.424v5.682h2.223v-6.66 L25.478,13.811z"
                />
            </IconBase>
        );
    }
}

export default OverviewIcon;



/** WEBPACK FOOTER **
 ** /src/shared/components/icons/Overview.js
 **/